export enum TextMessageType {
  NORMAL = 'SmsPlan::Normal',
  ALERT = 'SmsPlan::Alert',
}
